// Recovered from the preserved MetaCard production build.
// Behavior is retained; local names and TypeScript types were lost during minification.
export async function redeemPromocode(u, o) {
  const m = await fetch("/api/promocode/redeem", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        initData: u,
        code: o
      })
    }),
    r = await m.json().catch(() => null);
  if (!m.ok) throw new Error(r?.error || "Не удалось активировать промокод. Попробуйте ещё раз.");
  if (!r) throw new Error("Не удалось получить ответ. Попробуйте ещё раз.");
  return r;
}
